import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';
import { Policy } from '@wsphere/warranties/domain';

@Injectable()
export class PlanResolver implements Resolve<Policy.Plan.Model | null | RedirectCommand> {
  plan!: Policy.Plan.Model | null;

  async resolve(): Promise<Policy.Plan.Model | null> {
    return this.plan || null;
  }
}
